module.exports = __webpack_public_path__ + "static/media/photo-1555162928-38aca2d0be51.5d5b5c04.jfif";